
import "../Foundation/stylable/colors.st.css.js";
import "../IconButton/IconButton.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_PageHeader";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_PageHeader__root","header":"wds_1_76_1_PageHeader__header","breadcrumbsContainer":"wds_1_76_1_PageHeader__breadcrumbsContainer","titleContainer":"wds_1_76_1_PageHeader__titleContainer","titleBackButton":"wds_1_76_1_PageHeader__titleBackButton","titleBackButtonIcon":"wds_1_76_1_PageHeader__titleBackButtonIcon","titleColumn":"wds_1_76_1_PageHeader__titleColumn","title":"wds_1_76_1_PageHeader__title","actionsBar":"wds_1_76_1_PageHeader__actionsBar"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




